/**
 * This is event is triggered when the editor iframe is focused, usually by clicking.
 */
export const EDITOR_IFRAME_FOCUS_EVENT = 'docs-editor-iframe-focus'
